import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, SegmentedControl, Group, Text, TextInput } from "@mantine/core";
import { IconMail } from "@tabler/icons-react";

import { PaginatedList } from "../shared";

type AdminStatusFilter = "entire" | "1" | "2" | "4";

interface AdminListFilters {
  search_value: string;
  status: AdminStatusFilter;
}

interface AdminRecord {
  id: number | string;
  first_name?: string;
  last_name?: string;
  email?: string;
  [key: string]: unknown;
}

interface RequestInfo {
  url: string;
  data: Record<string, unknown>;
}

interface AdminListProps {
  items?: unknown[];
  requestInfo?: RequestInfo;
  refresh?: unknown;
  isIndex?: boolean;
}

export default function AdminList({
  items = [],
  requestInfo = {
    url: "/admin/retrieve-admins/",
    data: {},
  },
  refresh,
  isIndex: _isIndex,
}: AdminListProps) {
  const { t } = useTranslation();
  const [filters, setFilters] = useState<AdminListFilters>({
    search_value: "",
    status: "2",
  });

  const reqData = {
    ...filters,
    ...requestInfo.data,
    refresh,
  };

  return (
    <div>
      {requestInfo && (
        <React.Fragment>
          <TextInput
            placeholder={String(t("search"))}
            size="lg"
            value={filters.search_value}
            onChange={(e) =>
              setFilters({ ...filters, search_value: e.target.value })
            }
          />
          <SegmentedControl
            data={[
              { label: "All", value: "entire" },
              { label: String(t("active")), value: "2" },
              { label: String(t("created")), value: "1" },
              { label: String(t("disabled")), value: "4" },
            ]}
            value={filters.status}
            onChange={(value) =>
              setFilters({ ...filters, status: value as AdminStatusFilter })
            }
            mt="sm"
            size="xs"
          />
        </React.Fragment>
      )}
      <PaginatedList
        tableData={items as never[]}
        requestInfo={{
          url: requestInfo.url,
          data: reqData,
        }}
        responseMapping={(r: AdminRecord[]) =>
          r.map((m) => ({
            ...m,
            link_url: `/admins/${m.id}`,
          }))
        }
        displayFormatter={(item: { original: AdminRecord }) => {
          return (
            <Card key={item.original.id}>
              <Group gap="xs">
                <Text
                  fw={700}
                  component={Link}
                  to={`/admins/${item.original.id}`}
                  c="dark"
                >
                  {item.original.first_name} {item.original.last_name}
                </Text>
              </Group>
              <Group gap="xs">
                <IconMail size={16} />
                <Text size="sm">{item.original.email}</Text>
              </Group>
            </Card>
          );
        }}
      />
    </div>
  );
}
